<template>
  <transition name="slide">
      <music-list :title="title"
                :bg-image="bgImage"
                :songs="songs"></music-list>
    <!-- <music-list :title="title" :bg-image="bgImage" :songs="songs"></music-list> -->
  </transition>
</template>

<script type="text/ecmascript-6">
import MusicList from 'components/music-list/music-list'
import { getAudioBook } from 'api/recommend'
import { ERR_OK } from 'api/config'
import { mapGetters, mapMutations } from 'vuex'
// import {  } from 'vuex'
import { createSong } from 'common/js/song'

export default {
  computed: {
    title () {
      // return this.disc.name
    },
    bgImage () {
      return this.disc.imgDiscUrl
      // return 'https://fs.kimy.com.tw/audioBook/images/3e4f3b22-f48a-4585-8e2e-76353f96386e.jpg'
    },
    ...mapGetters(['disc'])
  },
  data () {
    return {
      songs: []
    }
  },
  created () {
    console.log('audiobook')
    this._getSongList()
  },
  methods: {
    // 歌曲列表
    _getSongList () {
      console.log('audiobook')
      // if (!this.disc.id) {
      //   this.$router.push('/recommend')
      //   return
      // }
      getAudioBook(this.$route.params.id).then(res => {
        if (res.code === ERR_OK) {
          console.log('res.data', res.data.book)
          var audiobook = res.data.book
          var item = {
            imgTitleUrl: audiobook.imgMagTitleUrl,
            imgDiscUrl: audiobook.imgDiscUrl,
            controllerBackgroundColor: audiobook.controllerBackgroundColor
          }
          this.setDisc(item)
          this.songs = this._normalizeSongs(res.data.book.list)
          // document.title = res.data.book.desc
        }
      })

      // this.songs = [
      //   {
      //     id: 7,
      //     name: '鵝',
      //     album: '鵝',
      //     image: 'https://fs.kimy.com.tw/childrenSongResource/images/6ea416fd-47e3-4366-b587-16f2fe5a06d0.jpg',
      //     url: 'https://fs.kimy.com.tw/childrenSongResource/music/70325a2c-4609-4ba2-9266-862d739b6f10.m4a',
      //     duration: 98,
      //     lyric: '<p>鵝</p><p>鵝</p><p>鵝</p><p>鵝</p>'
      //   },
      //   {
      //     id: 8,
      //     name: '鴨',
      //     album: '鴨',
      //     image: 'https://fs.kimy.com.tw/childrenSongResource/images/1090b789-b5c6-4a63-804e-2423319345ff.jpg',
      //     url: 'https://fs.kimy.com.tw/childrenSongResource/music/b9c68335-f372-41e1-ba68-e0c719fb7630.m4a',
      //     duration: 88,
      //     lyric: '鴨'
      //   }
      // ]
      // var item = {titleImgUrl: 'https://fs.kimy.com.tw/audioBook/images/745b21e6-5e76-4052-a677-3628f4e16019.jpg'}
      // item.titleImgUrl = 'https://fs.kimy.com.tw/audioBook/images/745b21e6-5e76-4052-a677-3628f4e16019.jpg'
      // this.setDisc(item)
      console.log('songs', this.songs)
    },
    _normalizeSongs (list) {
      console.log('_normalizeSongs->', list)
      let ret = []
      list.forEach(musicData => {
        // if (musicData.songid && musicData.albummid) {
        if (musicData.songUrl && musicData.imgUrl) {
          ret.push(createSong(musicData))
        }
      })
      console.log('disc-normalizeSong', ret)
      return ret
    },
    ...mapMutations({
      setDisc: 'SET_DISC'
    })
  },
  components: {
    MusicList
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s;
}

.slide-enter, .slide-leave-to {
  transform: translate3d(100%, 0, 0);
}
</style>


// WEBPACK FOOTER //
// audiobook.vue?252ef750